/**
 * Default invoice settings configuration (International)
 *
 * This is the fallback for countries without specific invoice requirements.
 * International regions typically don't have special e-invoice regulations.
 */

export default {
  // Whether this country has special invoice settings
  hasInvoiceSettings: false,

  // Whether e-invoice is required by law
  eInvoiceRequired: false,

  // Available carrier type options
  carrierTypeOptions: [],

  // Invoice field configurations
  fields: [],

  // Validation rules
  validations: {},

  // UI configuration
  ui: {
    showInvoiceSection: false,
    showCarrierTypeSelector: false,
  },

  // Format display strings
  formatCarrierDisplay: (carrierType, { carrierId, taxId, loveCode } = {}) => {
    return carrierType || 'Platform Invoice';
  },

  formatTaxIdDisplay: (taxId) => {
    if (!taxId) return null;
    return `Tax ID: ${taxId}`;
  },

  /**
   * Format e-invoice number for display
   * Default: return as-is (no special formatting)
   *
   * @param {string} num - Raw e-invoice number
   * @returns {string} Formatted number
   */
  formatEInvoiceNumber: (num) => num,
};
